// extracted by mini-css-extract-plugin
export default {"div_form":"FormLogin_div_form__3Vh2p","input":"FormLogin_input__21mmA","input_submit":"FormLogin_input_submit__8E4kM"};